<template>
  <div class="animated fadeIn">
    <div class="card dash-field">
      <div class="row m-0">
        <div class="card-body col-md-8">
          <h3>{{$t('WARRANTY')}}</h3>
        </div>
        <div class="col-md-4 m-auto">
            <button type="button" class="btn btn-add" @click="showModal()">
                {{$t('ADDWARRANTY')}}
            </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-form inline>
              <label class="mr-sm-2 d-inline">{{$t('ITEMSPERPAGE')}}</label>
              <b-form-select v-model="pagination.limit"
                :options="[{value: 25, text: '25'},{value: 50, text: '50'},{value: 100, text: '100'}]"></b-form-select>
            </b-form>
          </div>
          <div class="col-sm-6">
            <div class="buttons-group float-right">
              <label class="has-float-label mr-2" v-if="(globals.salesStaf != globals.groupId) && (globals.storeManager != globals.groupId)">
                  <b-form-fieldset>
                    <b-form-select class="col-sm-12 float-right" :options="store.root" v-model="pagination.storeId" value-field="storeId" text-field="name" :placeholder="$t('STORE')">
                    </b-form-select>     
                  </b-form-fieldset>
              </label>
              <label class="has-float-label mr-2">
                  <b-form-fieldset>                      
                    <b-form-input class="col-sm-12 float-right" v-model="pagination.query" :placeholder="$t('SEARCH')">
                    </b-form-input>
                  </b-form-fieldset>
              </label>
            </div>
          </div>
        </div>
        <div class="clear20">&nbsp;</div>
        <div class="row mb-2">          
          <div class="col-sm-12">            
            <loading v-if="loading" />
            <table class="table table-foursight table-striped table-hover table-sm table-responsive inline-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{{$t('WORKER')}}</th>
                  <th>{{$t('NAME')}}</th>
                  <th>{{$t('WARRANTY')}}</th>
                  <th>{{$t('TRACKING')}}</th>
                  <th>{{$t('GUESTINITIAL')}}</th>
                  <th>{{$t('ACTION')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in data.root">
                  <tr :key="item.warrantyId" aria-rowindex="1" class=" table-ellipsis" :class="`warranty-${item.status}`">
                    <td>
                       <icon @click="expand(item)" :icon="(item.showDetails != null && item.showDetails == true) ? 'minus' : 'plus'"></icon>
                    </td>
                    <td>{{item.userName}}</td>
                    <td>{{item.name}}</td>
                    <td v-html="item.warranty"></td>
                    <td>{{item.tracking}}</td>
                    <td :colspan="((globals.salesStaf != globals.groupId && globals.storeManager != globals.groupId) || (item.status != 'pending' && item.status != 'finished')) ? '1' : '3'">{{item.guestInitial}}</td>
                    <td v-if="((globals.salesStaf != globals.groupId && globals.storeManager != globals.groupId) || (item.status != 'pending' && item.status != 'finished'))">
                        <b-button type="button" size="sm" variant="primary" @click="exportToPdf(item)" class="m-1">{{$t('EXPORTTOPDF')}}</b-button>
                        <button v-if="item.imgSrc != null && item.imgSrc !== ''" class="ml-2 btn-view btn-sm" type="button" variant="a" @click="showImage(item)">{{$t('VIEWIMAGE')}}</button>
                        <b-button class="ml-2" type="button" size="sm" variant="secondary" @click="showModal(item)">{{$t('EDIT')}}</b-button>
                        <b-button class="ml-2" type="button" size="sm" variant="delete" @click="deleteRow(item.warrantyId)">{{$t('DELETE')}}</b-button>
                    </td>
                  </tr>
                  <tr v-if="(item.showDetails != null && item.showDetails == true) ? true : false">
                      <td colspan="12">
                      <div class="warranty-details-tb-data">
                        <div>
                          <p>{{$t('PHONE')}}:</p>
                          <span>{{item.phone}}</span>
                        </div>
                        <div>
                          <p>{{$t('RECEIPT')}}:</p>
                          <span>{{item.receipt}}</span>
                        </div>
                        <div>
                          <p>{{$t('BRAND')}}:</p>
                          <span v-html="item.brand"></span>
                        </div>
                        <div>
                          <p>{{$t('NAMEOFPRODUCT')}}:</p>
                          <span v-html="item.nameOfProduct"></span>
                        </div>
                      </div>
                      <div class="warranty-details-tb-data">
                        <div>
                          <p>{{$t('COLOR')}}:</p>
                          <span v-html="item.color"></span>
                        </div>
                        <div>
                          <p>{{$t('DATEOFPURCHASE')}}:</p>
                          <span>{{item.dateOfPurchase}}</span>
                        </div>
                        <div>
                          <p>{{$t('DETAILOFWARRANTY')}}:</p>
                          <span v-html="item.detailOfWarranty"></span>
                        </div>
                        <div>
                          <p>{{$t('PREFERENCE')}}:</p>
                          <span>{{item.preference}}</span>
                        </div>
                      </div>
                      </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <nav>
              <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage"
                :per-page="pagination.limit"></b-pagination>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <warrantyform v-model="formData" v-on:close="warrantyImage = null; getData()"></warrantyform>
    <b-modal ref="formimagemodal" :title="$t('IMAGE')" ok-title="submit" hide-footer size="lg" no-close-on-backdrop>
        <div class="d-block" v-if="warrantyImage != null">
            <div v-for="image in warrantyImage">
                <img class="mt-2" style="max-width: 100%;" :src="parseImage(image)" :alt="parseImage(image)">
            </div>
        </div>
        <div class="text-right">
            <b-btn class="mt-3" variant="secondary-trans mr-4" @click="warrantyImage = null;">{{$t('CLOSE')}}</b-btn>
        </div>
    </b-modal>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  import Api from '@/api/warranty/Warranty.js';
  import StoreApi from '@/api/salesportal/Store'

  import WarrantyForm from './Form.vue';
import Loading from '../../components/lib/Loading.vue';

  export default {
    name: 'StepButtons',
    components: {
      warrantyform: WarrantyForm,
        Loading,
    },
    data() {
      return {
        loading: true,
        warrantyImage: null,
        data: {},
        store: {},
        comboStoreId: null,
        formData: null,
        pagination: {
          query: '',
          storeId: null,
          currentPage: 1,
          limit: 25,
        },
        searchTimeout: false,
      };
    },
    created() {
      const me = this;
      me.getData();
      me.getStore();

      if (me.$route.query != null
      && me.$route.query.openForm !== null && me.$route.query.openForm == true)
      {
        setTimeout(() => {            
          const value = {...me.$route.query};
          me.$router.push({ query: {} });
          me.showModal(value);
        }, 300);
      }
    },
    methods: {
      expand(item)
      {
          if (item.showDetails != null && item.showDetails == true)
          {
              item.showDetails = false;
          }
          else
          {
              item.showDetails = true
          }

          console.log(item.showDetails);
      },
      parseImage(val)
      {

        if (val.indexOf('docfiles') !== -1)
        {
          return val;
        }
        return val.substring(1);
          
      },
      showImage(item)
      {
        const me = this;
        if (item.imgSrc != null && item.imgSrc !== '')
        {
          const imgageSources = item.imgSrc.split(',');
          me.warrantyImage = imgageSources;
        }
      },
      async getData() {
        const me = this;
        try {
          me.loading = true;
          const data = await Api.selectRow(me.getParams);
          if (data.error && data.error === true) {
            throw (data);
          }

          for (const item of data.root)
          {
              item.showDetails = false;
          }

          me.data = data;
        } catch (error) {
          me.$notify.notice(error);
        } finally {
          me.loading = false;
        }
      },
      async exportToPdf(item) {
        const me = this;
          try
          {
              await Api.printWarranty({warrantyId: item.warrantyId});
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getStore()
      {
        var me = this;
        try
        {
          var data = await StoreApi.selectRow();
          if (data.error && data.error == true)
          {
            me.$notify.notice(data);
            return;
          }

          data.root.unshift({storeId: null, name: me.$i18n.t('ALL')});
          me.store = data;
        }
        catch (e)
        {
          me.$notify.notice(e);
        }
      },
      async deleteRow(id) {
        const me = this;
        me.$store.commit('setModalAlert', {
          text: me.$i18n.t('AREYOUSHURE'),
          async btnAction() {
            const data = await Api.deleteRow({
              id
            });
            me.$notify.notice(data);
            me.getData();
          },
        });
      },
      showModal(item) {
        const me = this;
        if (typeof item == null) {
          item = {};
        }
        me.formData = {
          ...item
        };
      },
    },
    watch: {
      warrantyImage(val)
      {
        const me = this;
        if (val != null)
        {
          me.$refs.formimagemodal.show();
        }
        else
        {
          me.$refs.formimagemodal.hide();
        }
      },
      pagination: {
        deep: true,
        handler() {
          const me = this;

          if (me.searchTimeout !== false) {
            clearTimeout(me.searchTimeout);
          }

          me.searchTimeout = setTimeout(() => {
            me.getData();
            me.searchTimeout = false;
          }, 300);
        },
      },
      '$route.query': function(val)
      {
        var me = this;
        if (val.openForm != null && val.openForm == true)
        {
          me.$router.push({ query: {} });
          const value = {...val};
          me.showModal(value);
        }
      },
    },
    computed: {
      ...mapGetters([
        'globals',
      ]),
      getParams() {
        const me = this;
        const data = {
          ...me.pagination
        };
        data.start = (data.currentPage - 1) * data.limit;
        return data;
      },
    },
  };

</script>
